import { KnowledgeBaseBaseFragment } from "../../fragments/knowledge-base";
import { gql } from "@apollo/client";

export const QUERY_FETCH_KNOWLEDGE_BASES_BY_IDS = gql`
  query fetchKnowledgeBasesByIds($ids: [ID]) {
    knowledgebases: knowledgeBases_connection(
      sort: "createdAt:desc"
      filters: { documentId: { in: $ids }, publishedAt: { notNull: true } }
    ) {
      data {
        id
        documentId
        attributes {
          ...KnowledgeBaseBaseFragment
        }
      }
    }
  }
  ${KnowledgeBaseBaseFragment}
`;
